import { Wrench, Settings, Zap } from "lucide-react";
import { DefaultTooltip } from "twyne-new.ui";

import TextTruncated from "@/components/TextTruncated";
import useMaxLength from "@/components/hooks/useMaxLength";

export const Icons = ({ page: { path_pages, rules, dynamicNavigation } }) => {
  const icons = []
  if (path_pages && path_pages.rules) {
    icons.push({
      icon: Settings,
      hint: "Custom rules on this path",
    })
  } else if (rules) {
    icons.push({
      icon: Wrench,
      hint: "Default rules is active",
    })
  }
  if (dynamicNavigation) {
    icons.push({
      icon: Zap,
      hint: "Dynamic navigation is enabled",
    })
  }

  return <>
    {icons.map(({ icon: Icon, hint }) => <>
      <DefaultTooltip content={hint}>
        <Icon size='14' />
      </DefaultTooltip>
    </>)}
  </>
}

const TWYNE_EXTRA_FIELDS = {
  keys: ["pubid", "srcid", "url"],
  labels: {
    pubid: "pid: ",
    srcid: " | sid: ",
    url: " | twyne url: ",
  },
}

export const TYPE_ALAIASES = {
  "account-pw": {
    label: "Account Password",
    keyProperty: "accountpassword",
  },
  html: {
    label: "HTML",
    keyProperty: "html",
  },
  iframe: {
    label: "iframe",
    keyProperty: "iframe",
  },
  "partner-covalent": {
    label: "Covalent",
    keyProperty: "covalent",
    extraFields: {
      keys: ["plc_id"],
      labels: {
        plc_id: "plc id: ",
      },
    },
  },
  "partner-ifficient": {
    label: "Ifficient",
    keyProperty: "ifficient",
    extraFields: TWYNE_EXTRA_FIELDS,
  },
  "partner-nitro": {
    label: "Nitro",
    keyProperty: "nitro",
    extraFields: {
      keys: ["aff_id", "sid"],
      labels: {
        aff_id: "affiliate id: ",
        sid: " | sid: ",
      },
    },
  },
  "partner-fluent": {
    label: "Fluent",
    keyProperty: "fluent",
    extraFields: {
      keys: ["partnerId"],
      labels: {
        partnerId: "partner id: ",
      },
    },
  },
  "partner-optintelligence": {
    label: "Opt-Intelligence",
    keyProperty: "optintelligence",
    extraFields: TWYNE_EXTRA_FIELDS,
  },
  "partner-permissiondata": {
    label: "Permission Data",
    keyProperty: "permissiondata",
    extraFields: {
      keys: ["identifier"],
      labels: {
        identifier: "script identifier: ",
      },
    },
  },
  "partner-rexadz": {
    label: "RexAdz",
    keyProperty: "rexadz",
    extraFields: {
      keys: ["placementid"],
      labels: {
        placementid: "placement id: ",
      },
    },
  },
  "partner-react2": {
    label: "React2Media",
    keyProperty: "react2",
    extraFields: {
      keys: ["siteid", "publisherid", "securitykey"],
      labels: {
        siteid: "site id: ",
        publisherid: " | publisher id: ",
        securitykey: " | security key: ",
      },
    },
  },
  "partner-tiburon": {
    label: "Tiburon",
    keyProperty: "tiburon",
    extraFields: {
      keys: ["placementid", "pubid"],
      labels: {
        placementid: "placement id: ",
        pubid: " | pub id:",
      },
    },
  },
  "partner-twyne": {
    label: "Twyne",
    keyProperty: "twyne",
    extraFields: TWYNE_EXTRA_FIELDS,
  },
  "tcpa-confirmation": {
    label: "TCPA Confirmation",
    keyProperty: "tcpaconfirmation",
  },
  "tcpa-question": {
    label: "TCPA Question",
    keyProperty: 'tcpaquestion',
  },
  "tcpa-form": {
    label: "TCPA Form",
    keyProperty: "tcpaform",
  },
  "tcpa-linkout-question": {
    label: "TCPA Linkout",
    keyProperty: "linkoutquestion",
  },
  "tcpa-call-question": {
    label: "TCPA ClickToCall",
    keyProperty: "callquestion",
  },
  "tcpa-question-custom": {
    label: "TCPA Custom",
    keyProperty: "tcpaquestioncustom",
  },
}

const getExtraFields = ({ type, data = {} }) => {
  const { keys, labels } = TYPE_ALAIASES[type]?.extraFields || {}

  if (type.startsWith("tcpa") && data.cfid_number && data.cfid) return `custom field: [#${data.cfid_number}] ${data.cfid}`

  if (!keys || !labels) return ""

  return keys?.reduce((pageDetails, currentKey) => {
    if (!data[currentKey]) return pageDetails

    return pageDetails += `${labels[currentKey]}${data[currentKey]}`
  }, "")
}

export function PageDetails({ data }) {
  const { integrationDataParsed, type } = data
  const { keyProperty } = TYPE_ALAIASES[type] || {}
  const { [keyProperty]: extraData = {} } = integrationDataParsed || {}
  const { maxLength, ref } = useMaxLength(6)

  const text = getExtraFields({ type, data: extraData })
  if (!text) {
    return null
  }

  return <div className='text-sm twy-text-base w-full' ref={ref}>
    <TextTruncated maxLength={maxLength}>{text}</TextTruncated>
  </div>
}

